var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53808 1.80695C9.81799 1.62034 10.1827 1.62034 10.4626 1.80695L17.9626 6.80695C18.1944 6.96151 18.3337 7.2217 18.3337 7.50033C18.3337 7.77895 18.1944 8.03915 17.9626 8.1937L10.4626 13.1937C10.1827 13.3803 9.81799 13.3803 9.53808 13.1937L2.03808 8.1937C1.80624 8.03915 1.66699 7.77895 1.66699 7.50033C1.66699 7.2217 1.80624 6.96151 2.03808 6.80695L9.53808 1.80695ZM4.00264 7.50033L10.0003 11.4988L15.998 7.50033L10.0003 3.50187L4.00264 7.50033Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50033 6.66699C2.96056 6.66699 3.33366 7.04009 3.33366 7.50033V15.8337C3.33366 16.0547 3.42146 16.2666 3.57774 16.4229C3.73402 16.5792 3.94598 16.667 4.16699 16.667H15.8337C16.0547 16.667 16.2666 16.5792 16.4229 16.4229C16.5792 16.2666 16.667 16.0547 16.667 15.8337V7.50033C16.667 7.04009 17.0401 6.66699 17.5003 6.66699C17.9606 6.66699 18.3337 7.04009 18.3337 7.50033V15.8337C18.3337 16.4967 18.0703 17.1326 17.6014 17.6014C17.1326 18.0703 16.4967 18.3337 15.8337 18.3337H4.16699C3.50395 18.3337 2.86807 18.0703 2.39923 17.6014C1.93038 17.1326 1.66699 16.4967 1.66699 15.8337V7.50033C1.66699 7.04009 2.04009 6.66699 2.50033 6.66699Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08958 10.2441C8.41502 10.5695 8.41502 11.0972 8.08958 11.4226L3.08958 16.4226C2.76414 16.748 2.23651 16.748 1.91107 16.4226C1.58563 16.0972 1.58563 15.5695 1.91107 15.2441L6.91107 10.2441C7.23651 9.91864 7.76414 9.91864 8.08958 10.2441Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9111 10.2441C12.2365 9.91864 12.7641 9.91864 13.0896 10.2441L18.0896 15.2441C18.415 15.5695 18.415 16.0972 18.0896 16.4226C17.7641 16.748 17.2365 16.748 16.9111 16.4226L11.9111 11.4226C11.5856 11.0972 11.5856 10.5695 11.9111 10.2441Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenIcon);
export default __webpack_public_path__ + "static/media/MailOpenIcon.43d99a13e502b952151dc8c435afd69d.svg";
export { ForwardRef as ReactComponent };